<script setup lang="ts">
import { Teleport } from 'vue'
import GlobalHeader from '@/components/desktop/GlobalHeader/index.vue'
import MostRead from '@/components/desktop/MostRead/index.vue'
import Recommond from '@/components/desktop/SuggestList'
import FooterSiteMap from '@/components/desktop/GlobalFooter/FooterSiteMap.vue'
import FooterShare from '@/components/desktop/GlobalFooter/FooterShare.vue'
import GlobalShare from '@/components/desktop/GlobalShare/index.vue'
import RotatChart from '@/views/live/desktop/rotatChart/index.vue'

const imageListEl = document.querySelectorAll('#newContent img')

const imageList = []

imageListEl.forEach((el) => {
  if (el.getAttribute('src')) {
    imageList.push({
      src: el.getAttribute('src'),
      alt: el.getAttribute('alt'),
      des: el.parentNode?.querySelector('.images-item_details')?.innerHTML
    })
  }
})
</script>

<template>
  <Teleport to="#globalHeader">
    <GlobalHeader />
  </Teleport>
  <Teleport to="#globalShare">
    <GlobalShare />
  </Teleport>
  <Teleport to="#mostRead">
    <MostRead />
  </Teleport>
  <Teleport to="#recommend">
    <Recommond type="suggest" />
  </Teleport>
  <Teleport to="#footerSitemap">
    <FooterSiteMap />
  </Teleport>
  <Teleport to="#footerShare">
    <FooterShare />
  </Teleport>
  <Teleport to="#rotatChart">
    <rotatChart />
  </Teleport>
  <Teleport to="#imageList">
    <NImageGroup>
      <div class="images-item active" v-for="item in imageList" :key="item.src">
        <NImage
          style="width: 890px;"
          :src="item.src"
          object-fit="contain"
          width="890"
          :alt="item.alt"
          :height="500"
        />
        <div class="images-item_details droidSerif" v-html="item.des" />
      </div>
    </NImageGroup>
  </Teleport>
</template>

<style scoped lang="less">

</style>
